<script>
import IconImage from "@js/components/Icons/IconImage.vue";

export default {
    name: "SearchDesktopLoadingSkeleton",
    components: {IconImage}
}
</script>

<template>
    <div class="flex items-center gap-4 animate-pulse px-4 py-3">
        <div class="flex items-center justify-center w-[70px] h-[70px] bg-gray-300 rounded-md">
            <IconImage class="w-7 h-7"/>
        </div>
        <div class="flex-1 space-y-2">
            <div class="h-1.5 bg-gray-200 rounded w-1/5"></div>
            <div class="h-3 bg-gray-200 rounded w-3/4"></div>
            <div class="h-1.5 bg-gray-200 rounded w-1/5"></div>
            <div class="h-4 bg-baseColor rounded w-20"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
